import AuthService from '@/services/auth.service'
import UserService from '@/services/user.service'
import ProjectService from '@/services/project.service'
import {userActionTypes} from '../../actionTypes'

let types = userActionTypes

const state = {
    token: AuthService.getToken(),
    refreshToken: AuthService.getRefreshToken(),
    profile: {},
    wallet: {},
    projects: [],
    currentProjectId: '',
    // check data is loaded
    isProjectsLoaded: false,
    isCurrentProjectIdLoaded: false,
    isProfileLoaded: false
}

const mutations = {
    [types.TOKEN]: (state, token) => {
        state.token = token
        AuthService.setToken(token)
    },
    [types.REFRESH_TOKEN]: (state, token) => {
        state.refreshToken = token
        AuthService.setRefreshToken(token)
    },
    [types.PROFILE]: (state, profile) => {
        state.profile = profile
        state.isProfileLoaded = true
    },
    [types.PROJECTS]: (state, projects) => {
        state.projects = projects
        state.isProjectsLoaded = true
    },
    [types.CURRENT_PROJECT_ID]: (state, projectId, isNew) => {
        if (isNew) {
            if (this.projects.length > 0) {
                state.currentProjectId = state.projects[0].id
                AuthService.setCurrentProjectId(state.profile.email, state.projects[0].id)
            }
        } else {
            state.currentProjectId = projectId
            AuthService.setCurrentProjectId(state.profile.email, projectId)
        }
        state.isCurrentProjectIdLoaded = true
    }
}

const actions = {
    [types.GET_PROJECTS]({commit}) {
        if (AuthService.getToken()) {
            return new Promise((resolve, reject) => {
                ProjectService.getListProject().then(res => {
                    commit(types.PROJECTS, res.data)
                    resolve()
                }).catch(err => {
                    commit(types.PROJECTS, [])
                    reject(err)
                })
            })
        } else {
            return null
        }
    },
    [types.CURRENT_PROJECT_ID]({commit}, projectId) {
        commit(types.CURRENT_PROJECT_ID, projectId)
        return true
    },
    [types.GET_PROFILE]({commit}) {
        UserService.getProfile().then(res => {
            commit(types.PROFILE, res.data)
            let targetProjectId = window.vueapp.$route.params['project_id']
            if (targetProjectId) {
                commit(types.CURRENT_PROJECT_ID, targetProjectId, false)
                return
            }
            let currentProjectId = AuthService.getCurrentProjectId(res.data.email)
            commit(types.CURRENT_PROJECT_ID, currentProjectId, !currentProjectId)
        })
    },
    [types.GET_JWT_USER]: ({commit}, code) => {
        return new Promise((resolve, reject) => {
            UserService.getJwtUser(code).then(res => {
                commit(types.PROFILE, res.data)
                commit(types.TOKEN, res.data.token)
                commit(types.REFRESH_TOKEN, res.data.refresh)
                AuthService.broadcastTokenUpdate()
                resolve()
            }).catch(err => {
                reject(err)
            })
        })
    },
    [types.RESET_TOKEN]({commit}) {
        return new Promise(resolve => {
            commit(types.TOKEN, '')
            commit(types.PROFILE, {})
            AuthService.removeToken()
            resolve()
        })
    },
    [types.SIGN_IN]({commit}) {
        AuthService.signIn()
    },
    [types.SIGN_OUT]({commit}) {
        // Broadcast BEFORE calling API logout — other tabs stop refreshing immediately
        // This minimizes race condition with backend token blacklist
        AuthService.broadcastLogout()
        AuthService.signOutJWTToken().finally(() => {
            commit(types.TOKEN, '')
            commit(types.REFRESH_TOKEN, '')
            commit(types.PROFILE, {})
            AuthService.removeRefreshToken()
            AuthService.signOut()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
